import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Footer from '../components/Footer';
import '../styles/PrivacyPolicy.css';

function PrivacyPolicy() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <motion.div
            className="privacy-page"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
        >
            <nav className="navbar">
                <div className="nav-container">
                    <div className="logo">
                        <Link to="/">
                            <img src="/images/logo.png" alt="Fotomista" />
                        </Link>
                    </div>
                    <ul className="nav-menu">
                        <li><Link to="/">الرئيسية</Link></li>
                        <li><Link to="/contact">اتصل بنا</Link></li>
                    </ul>
                </div>
            </nav>

            <section className="privacy-hero">
                <div className="privacy-container">
                    <motion.h1
                        initial={{ y: -20, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ delay: 0.2 }}
                    >
                        سياسة الخصوصية
                    </motion.h1>

                    <motion.p
                        className="privacy-subtitle"
                        initial={{ y: -20, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ delay: 0.3 }}
                    >
                        نلتزم بحماية خصوصيتك وبياناتك الشخصية وفقاً لنظام حماية البيانات الشخصية (PDPL)
                    </motion.p>

                    <motion.div
                        className="privacy-last-updated"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.35 }}
                    >
                        آخر تحديث: ٤ مارس ٢٠٢٦
                    </motion.div>

                    <motion.div
                        className="privacy-content"
                        initial={{ y: 30, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ delay: 0.4 }}
                    >

                        <div className="privacy-section">
                            <h2>١. مقدمة</h2>
                            <p>
                                تلتزم فوتوميستا (Fotomista) بحماية خصوصية مستخدميها وعملائها. تُوضح هذه السياسة كيفية جمع واستخدام وحماية بياناتكم الشخصية عند استخدام موقعنا الإلكتروني أو خدماتنا، وذلك وفقاً لنظام حماية البيانات الشخصية في المملكة العربية السعودية (PDPL).
                            </p>
                            <p>
                                يُدير هذه الخدمة <strong>حسن محمد بن صالح القطان</strong>، بموجب وثيقة العمل الحر رقم <strong>FL-547130542</strong>.
                            </p>
                        </div>

                        <div className="privacy-section">
                            <h2>٢. البيانات التي نجمعها</h2>
                            <p>نقوم بجمع الأنواع التالية من البيانات الشخصية عند استخدامك لخدماتنا:</p>

                            <div className="data-category">
                                <h3>بيانات الحجز</h3>
                                <ul>
                                    <li>الاسم الكامل</li>
                                    <li>رقم الجوال</li>
                                    <li>البريد الإلكتروني</li>
                                    <li>تاريخ ومكان المناسبة</li>
                                    <li>نوع الكابينة المختارة</li>
                                </ul>
                            </div>

                            <div className="data-category">
                                <h3>بيانات الدفع</h3>
                                <ul>
                                    <li>تتم معالجة بيانات الدفع بالكامل عبر بوابات الدفع المعتمدة (Geidea / Tamara)</li>
                                    <li>لا نقوم بتخزين بيانات البطاقات الائتمانية أو أرقام الحسابات البنكية على خوادمنا</li>
                                </ul>
                            </div>

                            <div className="data-category">
                                <h3>بيانات الاستخدام</h3>
                                <ul>
                                    <li>نوع المتصفح والجهاز المستخدم</li>
                                    <li>عنوان بروتوكول الإنترنت (IP)</li>
                                    <li>صفحات الموقع التي تمت زيارتها</li>
                                    <li>وقت وتاريخ الزيارة</li>
                                </ul>
                            </div>
                        </div>

                        <div className="privacy-section">
                            <h2>٣. أغراض جمع البيانات</h2>
                            <p>نستخدم بياناتك الشخصية للأغراض التالية:</p>
                            <ul>
                                <li>معالجة وتأكيد حجوزات كبائن التصوير</li>
                                <li>التواصل معك بشأن حجزك (تأكيد، تذكير، تحديثات)</li>
                                <li>معالجة المدفوعات واسترداد المبالغ عند الحاجة</li>
                                <li>إرسال التذاكر والفواتير الإلكترونية</li>
                                <li>تحسين جودة خدماتنا وتجربة المستخدم</li>
                                <li>الامتثال للمتطلبات القانونية والتنظيمية في المملكة</li>
                            </ul>
                        </div>

                        <div className="privacy-section">
                            <h2>٤. الأساس القانوني لمعالجة البيانات</h2>
                            <p>نعالج بياناتك الشخصية بناءً على الأسس القانونية التالية وفقاً لنظام حماية البيانات الشخصية:</p>
                            <ul>
                                <li><strong>تنفيذ العقد:</strong> معالجة البيانات اللازمة لتنفيذ حجزك وتقديم الخدمة</li>
                                <li><strong>الموافقة:</strong> عند تقديمك لبياناتك طوعاً خلال عملية الحجز</li>
                                <li><strong>المصلحة المشروعة:</strong> تحسين خدماتنا وحماية أمن الموقع</li>
                                <li><strong>الالتزام القانوني:</strong> الامتثال للأنظمة واللوائح المعمول بها</li>
                            </ul>
                        </div>

                        <div className="privacy-section">
                            <h2>٥. مشاركة البيانات مع أطراف ثالثة</h2>
                            <p>لا نقوم ببيع بياناتك الشخصية لأي طرف ثالث. قد نشارك بياناتك في الحالات التالية فقط:</p>
                            <div className="third-party-list">
                                <div className="third-party-item">
                                    <div className="tp-icon">¤</div>
                                    <div className="tp-content">
                                        <h3>بوابات الدفع</h3>
                                        <p>Geidea و Tamara — لمعالجة المدفوعات فقط، وتخضع لسياسات الخصوصية الخاصة بها.</p>
                                    </div>
                                </div>
                                <div className="third-party-item">
                                    <div className="tp-icon">@</div>
                                    <div className="tp-content">
                                        <h3>خدمات البريد الإلكتروني</h3>
                                        <p>لإرسال رسائل تأكيد الحجز والتذاكر الإلكترونية.</p>
                                    </div>
                                </div>
                                <div className="third-party-item">
                                    <div className="tp-icon">⚖</div>
                                    <div className="tp-content">
                                        <h3>الجهات الحكومية</h3>
                                        <p>عند الطلب من الجهات الرسمية المختصة وفقاً للأنظمة المعمول بها.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="privacy-section highlight-section">
                            <h2>٦. حقوقك</h2>
                            <p>وفقاً لنظام حماية البيانات الشخصية (PDPL)، لديك الحقوق التالية:</p>
                            <div className="rights-grid">
                                <div className="right-card">
                                    <div className="right-icon">◉</div>
                                    <h3>حق الاطلاع</h3>
                                    <p>الاطلاع على بياناتك الشخصية التي نحتفظ بها</p>
                                </div>
                                <div className="right-card">
                                    <div className="right-icon">✎</div>
                                    <h3>حق التصحيح</h3>
                                    <p>طلب تصحيح أو تحديث بياناتك غير الدقيقة</p>
                                </div>
                                <div className="right-card">
                                    <div className="right-icon">✕</div>
                                    <h3>حق الحذف</h3>
                                    <p>طلب حذف بياناتك الشخصية مع مراعاة الالتزامات القانونية</p>
                                </div>
                                <div className="right-card">
                                    <div className="right-icon">⊘</div>
                                    <h3>حق الاعتراض</h3>
                                    <p>الاعتراض على معالجة بياناتك في حالات معينة</p>
                                </div>
                            </div>
                            <p className="rights-note">
                                لممارسة أي من حقوقك، يرجى التواصل معنا عبر البريد الإلكتروني: <a href="mailto:fotomista.sa@gmail.com">fotomista.sa@gmail.com</a>
                            </p>
                        </div>

                        <div className="privacy-section">
                            <h2>٧. أمن البيانات</h2>
                            <p>نتخذ تدابير أمنية مناسبة لحماية بياناتك الشخصية من الوصول غير المصرح به أو الإفصاح أو التعديل أو الإتلاف، وتشمل هذه التدابير:</p>
                            <ul>
                                <li>استخدام تشفير SSL/TLS لتأمين نقل البيانات عبر الموقع</li>
                                <li>تخزين البيانات على خوادم آمنة ومحمية</li>
                                <li>تقييد الوصول إلى البيانات الشخصية على الأشخاص المخولين فقط</li>
                                <li>معالجة بيانات الدفع عبر بوابات دفع معتمدة ومتوافقة مع معايير PCI DSS</li>
                            </ul>
                        </div>

                        <div className="privacy-section">
                            <h2>٨. ملفات تعريف الارتباط (Cookies)</h2>
                            <p>
                                قد يستخدم موقعنا ملفات تعريف الارتباط لتحسين تجربة المستخدم. ملفات تعريف الارتباط هي ملفات نصية صغيرة تُخزن على جهازك عند زيارة موقعنا.
                            </p>
                            <p>نستخدم الأنواع التالية من ملفات تعريف الارتباط:</p>
                            <ul>
                                <li><strong>ملفات ضرورية:</strong> لتشغيل الموقع بشكل صحيح وتوفير الخدمات الأساسية</li>
                                <li><strong>ملفات تحليلية:</strong> لفهم كيفية استخدام الزوار للموقع وتحسين أدائه</li>
                            </ul>
                            <p>يمكنك التحكم في ملفات تعريف الارتباط عبر إعدادات المتصفح الخاص بك.</p>
                        </div>

                        <div className="privacy-section">
                            <h2>٩. الاحتفاظ بالبيانات</h2>
                            <p>
                                نحتفظ ببياناتك الشخصية للمدة اللازمة لتحقيق الأغراض المذكورة في هذه السياسة، أو وفقاً لما تتطلبه الأنظمة واللوائح المعمول بها في المملكة العربية السعودية. عند انتهاء الحاجة إلى البيانات، يتم حذفها أو إخفاء هويتها بشكل آمن.
                            </p>
                            <div className="data-category">
                                <h3>الصور الملتقطة خلال المناسبة</h3>
                                <p>
                                    تقدم فوتوميستا صوراً مطبوعة فقط ولا يتم تقديم نسخ رقمية. يتم حذف جميع الملفات الرقمية المؤقتة من أنظمتنا بعد انتهاء المناسبة مباشرةً ولا نحتفظ بأي نسخ منها.
                                </p>
                            </div>
                        </div>

                        <div className="privacy-section">
                            <h2>١٠. حماية بيانات القُصّر</h2>
                            <p>
                                خدماتنا غير موجهة للأشخاص دون سن ١٨ عاماً. لا نجمع عمداً بيانات شخصية من القُصّر. إذا علمنا أننا جمعنا بيانات شخصية من قاصر دون موافقة ولي الأمر، سنتخذ الإجراءات اللازمة لحذف تلك البيانات فوراً.
                            </p>
                        </div>

                        <div className="privacy-section">
                            <h2>١١. التعديلات على السياسة</h2>
                            <p>
                                قد نقوم بتحديث سياسة الخصوصية من وقت لآخر. سيتم نشر أي تعديلات على هذه الصفحة مع تحديث تاريخ «آخر تحديث». ننصحك بمراجعة هذه السياسة بشكل دوري للاطلاع على أي تغييرات.
                            </p>
                        </div>

                        <div className="privacy-section">
                            <h2>١٢. التواصل</h2>
                            <p>لأي استفسارات أو شكاوى تتعلق بسياسة الخصوصية أو بياناتك الشخصية، يمكنكم التواصل معنا عبر:</p>
                            <div className="contact-info-box">
                                <div className="contact-info-item">
                                    <span className="contact-label">البريد الإلكتروني:</span>
                                    <a href="mailto:fotomista.sa@gmail.com">fotomista.sa@gmail.com</a>
                                </div>
                                <div className="contact-info-item">
                                    <span className="contact-label">واتساب:</span>
                                    <a href="https://wa.me/966503859150" target="_blank" rel="noopener noreferrer">+966503859150</a>
                                </div>
                            </div>
                        </div>

                    </motion.div>
                </div>
            </section>

            <Footer />
        </motion.div>
    );
}

export default PrivacyPolicy;
